<template>
  <permit-to-work :site-id="site.id" />
</template>

<script>

import PermitToWork from '@/components/permits/PermitToWork'

export default {
  components: {
    PermitToWork
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },


  data () {
   return {
     site: this.rowData
   }
  }
}
</script>



// WEBPACK FOOTER //
// SitePermitToWork.vue?d0657bf4